import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { DriveBrowser } from "@/features/files/drive-browser"
import { DrivePageActions } from "@/features/files/drive-page-actions"
import { DriveProvider } from "@/features/files/drive-provider"
import { DriveUploadQueue } from "@/features/files/drive-upload-queue"
import { driveQueries } from "@/queries/drive"
import type { DriveOwner } from "@/types/drive"

const searchSchema = z.object({
  folder: z.uuid().optional(),
})

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/files/"
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps, params }) =>
    context.queryClient.ensureQueryData(
      driveQueries.list(
        { type: "individual", id: params.individualId },
        deps.folder ?? null
      )
    ),
  component: IndividualFilesPage,
})

function IndividualFilesPage() {
  const { individualId } = Route.useParams()
  const { folder } = Route.useSearch()
  const navigate = Route.useNavigate()
  const owner: DriveOwner = { type: "individual", id: individualId }

  return (
    <DriveProvider owner={owner} folderId={folder ?? null}>
      <PageHeader title="Files" actions={<DrivePageActions />} />
      <DriveBrowser
        onFolderChange={(folderId) =>
          void navigate({ search: { folder: folderId ?? undefined } })
        }
      />
      <DriveUploadQueue />
    </DriveProvider>
  )
}
